import React from "react";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";

export function ErrorPage1() {
    return (
        <div className="error-page-1">
            <div
                className="bg_image_cover p-sm-30"
                style={{
                    backgroundImage: `url(${toAbsoluteUrl("/media/error/bg1.jpg")})`,
                }}
            >
                <h1>404</h1>
                <p>OOPS! Something went wrong here</p>
            </div>
        </div>
    );
}
